export default {
  isLoggedIn: state => state.isLoggedIn,
  isSessionAlive: state => state.isSessionAlive,
  isSSO: state => state.sso,
  getUser: state => state.user,
  getToken: state => state.token,
  getAzcAccessToken: state => state.azcAccessToken,
  getAzcRefreshToken: state => state.azcRefreshToken,
  getGame: state => state.game,
  getDomain: state => state.domain,
  getLocale: state => state.locale,
  unseenNotificationCount: state => state.unseenNotificationCount,
  notificationList: state => state.notificationList
};
